import { Link } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

const TYPE_FORM_ES_URL = 'https://factorial.typeform.com/to/I1uhCayh'
const TYPE_FORM_GLOBAL_URL = 'https://factorial.typeform.com/to/NkotzAdb'

const FinanceOverviewBetaAdvisoryBanner = () => {
  const {
    access: { locale: userLocale },
    company: { locale: companyLocale },
  } = useCurrentSession()

  const typeformURL =
    (userLocale || companyLocale) === 'es' ? TYPE_FORM_ES_URL : TYPE_FORM_GLOBAL_URL

  return (
    <Callout
      title={i18n.t('finance.overview.beta_advisory_banner.title')}
      description={i18n.t('finance.overview.beta_advisory_banner.description')}
      type="warning"
      link={
        <Link.Href href={typeformURL} external target="_blank">
          {i18n.t('finance.overview.beta_advisory_banner.send_feedback')}
        </Link.Href>
      }
    />
  )
}

export default FinanceOverviewBetaAdvisoryBanner
